import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, FormPage, TreeContext } from 'src/components'
import { $consts } from 'src/plugins'
import { getEqualStrObject } from 'src/utils/tools'

type Props = {
  config: ButtonConfig
}

const FormModalBtn = (props: Props) => {
  const tree = useContext(TreeContext)

  const formData = useMemo(() => {
    const { __RECORD__: record, CUSTOM_PARAMS } = props.config
    return {
      formId: record.ID,
      fromWhere: {
        pageType: $consts['TABLE/FORM_TYPE_TREE_PAGE'],
        locateType: $consts['TABLE/BTN_LOCATE_HEADER'],
        data: {
          ...getEqualStrObject(CUSTOM_PARAMS),
          ...record
        }
      }
    }
  }, [props.config.__RECORD__, props.config.CUSTOM_PARAMS])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  const formCode = FORM_CODE || tree.treeConfig.Nav_Form?.CODE
  return (
    <EasyModal
      modal={{ title: formCode, width: WIDTH }}
      slot={<EasyIcon title={LABEL} type={ICON} defaultIcon='FormOutlined' />}
    >
      <FormPage formCode={formCode} formData={formData} />
    </EasyModal>
  )
}

export default FormModalBtn